// store/slices/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  isAuthenticated: boolean;
  user: any;
  status: 'idle' | 'loading' | 'loaded';
}

const initialState: UserState = {
  isAuthenticated: false,
  user: null,
  status: 'idle',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<any>) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.status = 'loaded';
      localStorage.setItem('authUser', JSON.stringify(action.payload));
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.status = 'loaded';
      localStorage.removeItem('authUser');
    },
    loadUserFromStorage(state) {
      state.status = 'loading';
      const storedUser = localStorage.getItem('authUser');
      if (storedUser) {
        state.user = JSON.parse(storedUser);
        state.isAuthenticated = true;
      }
      state.status = 'loaded';
    },
  },
});

export const { login, logout, loadUserFromStorage } = authSlice.actions;
export default authSlice.reducer;
